import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const AP_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ap.Planning', { route: '/ap/plannings' }],
            ['ap.PlanningAgent', { route: '/ap/planningAgents' }],
            ['ap.Planner', {route: '/ap/planners'}],
            ['ap.PlannerAgent', {route: '/ap/plannerAgents'}],
            ['ap.PlannerAgentPool', {route: '/ap/plannerAgentPools'}],
            ['ap.PlannerAgentStatus', {route: '/ap/plannerAgentStatuss'}],
            ['ap.CustomerGroupDefinition', {route: '/ap/customerGroupDefinitions'}],
            ['ap.CustomerGroup', {route: '/ap/customerGroups'}],
            ['ap.CustomerGroupRule', {route: '/ap/customerGroupRules'}],
            ['ap.RelevantAddressType', {route: '/ap/relevantAddressTypes'}]
        ] as EntityServiceEntry[],
        multi: true
    }
];
